/* eslint-disable no-use-before-define */
import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useMutation } from '@apollo/client'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import Icon from '@material-ui/core/Icon'
import appClient from '@services'
import { remove } from 'local-storage'
import { useUserDispatcher } from '@hooks'

import ConfirmationDialog from './localComponents/ConfirmationDialog'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import { Input } from '@material-ui/core'
import { TOPICS } from '../../services/app/mutation'
import config from '@config'
import { useAxios } from '../../hooks/useAxios'

function Alert(props: any) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    width: 350,
    marginLeft: 8,
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}))

const PushNotification: React.FC = () => {
  const axios = useAxios()
  const classes = useStyles()
  const [isLoading, setIsLoading] = useState(false)
  const [openSnackBar, setOpenSnackbar] = useState(false)
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)
  const [headline, setHeadline] = useState('')
  const [message, setMessage] = useState('')
  const [asset, setAsset] = useState()
  const [topic, setTopic] = useState(TOPICS.APPUPDATE_NOTIFICATION)

  const [alert, setAlert] = useState({
    isError: false,
    message: ``
  })
  const [errorHeadline, setErrorHeadline] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)


  const handleSendPushNotification = async () => {
    setIsLoading(true)

    try {
      const formData = new FormData()
      formData.append('title', headline)
      formData.append('body', message)
      formData.append('topic', topic)

      if (asset && asset.length) {
        formData.append(`file`, asset[0])
      }

      await axios.post(`pushnotifications`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setAlert({
        isError: false,
        message: `Push notification has successfully sent!`
      })
    }
    catch (e) {
      debugger
      console.log(e.message)
      setAlert({
        isError: true,
        message: e.response.data.message
      })
    } finally {
      setOpenConfirmationDialog(false)
      setIsLoading(false)
      setOpenSnackbar(true)
    }

    // try {
    //   setIsLoading(true)
    //   var targetDate = sendDate === '' ? null : new Date(sendDate)
    //   const sendPushNotificationVariables = {
    //     title,
    //     body,
    //     notificationTopic: topic,
    //     notificationSendType: sendType,
    //     sendDate: targetDate
    //   }

    //   const sendPushNotificationResponse = await sendPushNotification({ variables: sendPushNotificationVariables })

    //   const { result } = sendPushNotificationResponse.data.sendPushNotification as IServiceResponse<boolean>
    //   setIsPushNotificationSent(result)

    //   if (result) {
    //     setOpenSnackbar(true)
    //     setTitle('')
    //     setBody('')
    //     setSendDate('')
    //   }
    // } catch (e) {
    //   if (e?.graphQLErrors[0]?.extensions?.code == "authorization") {
    //     goToLogin()
    //     return
    //   }

    //   console.error(e)
    // }
    // setIsLoading(false)
  }

  const handleOnCloseSnackbar = () => {
    setAlert({
      isError: false,
      message: ``
    })
    setOpenSnackbar(false)
  }
  //Max chars for title and body and other data are 4000bytes, but to prevent issue we limit to 1024 for body
  //https://firebase.google.com/docs/cloud-messaging/concept-options
  return <div style={{
    border: '1px solid #dedede',
    padding: '20px',
    borderRadius: '5px',
    background: '#fff',
    width: '400px'
  }}>
    <h3>Push Notification</h3>
    <Snackbar open={openSnackBar} onClose={handleOnCloseSnackbar} autoHideDuration={6000}>
      <Alert onClose={handleOnCloseSnackbar} severity={!alert.isError ? 'success' : 'error'}>
        {alert.message}
      </Alert>
    </Snackbar>
    {openConfirmationDialog && <ConfirmationDialog disabled={isLoading} open={openConfirmationDialog} handleYes={handleSendPushNotification} handleNo={() => setOpenConfirmationDialog(false)} />}
    <form className={classes.root} noValidate autoComplete="off">
      <FormControl fullWidth>
        <TextField
          autoFocus
          id="Headline"
          label="Headline*"
          value={headline}
          fullWidth
          inputProps={{ maxLength: 50, shrink: true, }}
          disabled={isLoading}
          onChange={e => {
            const value = e.currentTarget.value
            setHeadline(value)
            setErrorHeadline(value ? false : true)
          }}
        />
        {errorHeadline && <span style={{ color: 'red', fontSize: 12 }}>Headline is required</span>}
      </FormControl>

      <FormControl fullWidth>
        <TextField
          id="Message"
          label="Message*"
          disabled={isLoading}
          value={message}
          fullWidth
          inputProps={{ maxLength: 1024, shrink: true, }}
          multiline={true}
          rows="5"
          rowsMax="5"
          onChange={e => {
            const value = e.currentTarget.value
            setMessage(value)
            setErrorMessage(value ? false : true)
          }}
        />
        {errorMessage && <span style={{ color: 'red', fontSize: 12 }}>Message is required</span>}
      </FormControl>

      <FormControl fullWidth>
        <InputLabel htmlFor="Asset" shrink>Asset</InputLabel>
        <Input
          id="Asset"
          type="file"
          disabled={isLoading}
          fullWidth
          onChange={e => {
            setAsset(e.target.files)
          }}
        />
      </FormControl>

      <FormControl fullWidth>
        <InputLabel htmlFor="topic">Topic*</InputLabel>
        <Select
          native
          value={topic}
          disabled={isLoading}
          onChange={e => {
            const value = e.currentTarget.value
            setTopic(value)
          }}
          inputProps={{
            name: 'topic',
            id: 'topic',
          }}
          fullWidth
        >
          <option value={TOPICS.APPUPDATE_NOTIFICATION}>App Update</option>
          <option value={TOPICS.DAILYFEED_NOTIFICATION}>Daily Feed</option>
          <option value={TOPICS.NEWS_NOTIFICATION}>News</option>
          <option value={TOPICS.SPECIALOFFERS_NOTIFICATION}>Special Offers</option>
        </Select>
      </FormControl>


      {/* TODO: WILL ENABLED ONCE THIS FEATURE NEEDED */}
      {/* <FormControl fullWidth>
        <InputLabel htmlFor="sendType">Send Type*</InputLabel>
        <Select
          native
          value={sendType}
          disabled={isLoading}
          onChange={e => {
            const value = e.currentTarget.value
            setSendType(value)
            setErrorSendType(value === '')

            if (value === NotificationSendTypeEnum.ONDATE) {
              setSendDate('')
              setErrorSendDate(false)
            }
          }}
          inputProps={{
            name: 'sendType',
            id: 'sendType',
          }}
          fullWidth
        >
          <option value={NotificationSendTypeEnum.DAILY}>Daily</option>
          <option value={NotificationSendTypeEnum.DIRECT}>Direct</option>
          <option value={NotificationSendTypeEnum.ONDATE}>On Date</option>
          <option value={NotificationSendTypeEnum.MONTHLY}>Montly</option>
          <option value={NotificationSendTypeEnum.WEEKLY}>Weekly</option>
        </Select>
        {errorSendType && <span style={{ color: 'red', fontSize: 12 }}>Send Type is required</span>}
      </FormControl> */}

      {/* TODO: WILL ENABLED ONCE THIS FEATURE NEEDED */}
      {/* {sendType === NotificationSendTypeEnum.ONDATE && (<FormControl fullWidth>
        <TextField
          autoFocus
          id="sendDate"
          label="Send Date*"
          value={sendDate}
          fullWidth
          type="datetime-local"
          disabled={isLoading}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={e => {
            const value = e.currentTarget.value
            setSendDate(value)
            setErrorSendDate(value === '')
          }}
        />
        {errorSendDate && <span style={{ color: 'red', fontSize: 12 }}>Send Date is required</span>}
      </FormControl>)} */}

      <FormControl>
        <Button disabled={isLoading} variant="contained" startIcon={<Icon>send</Icon>} onClick={() => {
          if (!headline) {
            setErrorHeadline(true)
            return
          }

          if (!message) {
            setErrorMessage(true)
            return
          }
          setOpenConfirmationDialog(true)



          // const isTitleEmpty = title === ''
          // const isBodyEmpty = body === ''
          // const isTopic = topic === ''
          // const isSendType = sendType === ''
          // // const isSendDate = sendType === NotificationSendTypeEnum.ONDATE && sendDate === ''

          // setErrorTitle(isTitleEmpty)
          // setErrorBody(isBodyEmpty)
          // setErrorTopic(isTopic)
          // setErrorSendType(isSendType)

          // if (isTitleEmpty || isBodyEmpty || isTopic || isSendType) {
          //   return
          // }

          // setOpenConfirmationDialog(true)


        }} color="primary">
          Send
        </Button>
      </FormControl>
    </form >
  </div >
}

export default PushNotification